import React from 'react';
import parse from 'html-react-parser';
import { Link } from 'react-router-dom';

/**
 * HtmlContent Component
 * 
 * Safely renders HTML content from the legacy site or CMS while preserving
 * the exact structure and formatting. Converts legacy links to React Router links
 * for internal navigation while keeping external links as standard <a> tags.
 */
const HtmlContent = ({ 
  html, 
  className = 'tool-opening',
  containerClass = 'tool-opening-container'
}) => {
  if (!html) return null;
  
  // Custom options for html-react-parser
  const options = {
    replace: (domNode) => {
      // Handle internal links, convert to React Router Links
      if (domNode.name === 'a' && domNode.attribs && domNode.attribs.href) {
        const href = domNode.attribs.href;
        
        // Only convert internal links
        if (href.startsWith('/') && !href.startsWith('//') && !href.match(/\.(pdf|doc|xls|ppt|zip|rar|jpg|png|gif)$/i)) {
          return (
            <Link 
              to={href} 
              className={domNode.attribs.class || ''} 
              title={domNode.attribs.title || ''}
            >
              {domNode.children && domNode.children.map(child => {
                if (child.type === 'text') {
                  return child.data;
                } else {
                  // For nested elements, recursively parse them
                  return parse(child.data || '', options);
                }
              })}
            </Link>
          );
        }
      }
      
      // Don't modify other elements
      return undefined;
    }
  };
  
  // Container element is optional
  if (!containerClass) {
    return (
      <div className={className}>
        {parse(html, options)}
      </div>
    );
  }
  
  return (
    <div className={containerClass}>
      <div className={className}>
        {parse(html, options)}
      </div>
    </div>
  );
};

export default HtmlContent; 